import { apiClient } from "../Utils/apiClient";

export const getCourseData = async () => {
  return await apiClient("get", "/v1/b2b/course/all/active");
};

export const getAllCenter  = async (data) => {
  return await apiClient("post", "/v1/client/center/centers/course/batch",data);
};